/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";
import type { PaywallVisitMetadataVisitTypePreference } from "./PaywallVisitMetadataVisitTypePreference";
import type { ProductOption } from "./ProductOption";

export interface PaywallVisitMetadata {
  /** Optional partner intent to be provided from FE local storage. */
  partner_intent?: PartnerIntentRequest | null;
  /** Deprecated: send clinic_request_id on the request root instead. */
  clinic_request_id?: string | null;
  /** The user's preferred visit type */
  visit_type_preference: PaywallVisitMetadataVisitTypePreference;
  /** Vendor-neutral id of the eligibility check run the price was based on, set when payment_mode is 'insurance'. (From PatientResponsibilityResponse.run_id.) */
  insurance_eligibility_check_id?: string | null;
  /** Product selected before entering the progression */
  payment_product_option?: ProductOption | null;
}
